/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Access_IncludedInputs */

const fr_membership_access_included = /** @type {(inputs: Membership_Access_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclus`)
};

/**

* @param {Membership_Access_IncludedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_access_included = /** @type {((inputs?: Membership_Access_IncludedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Access_IncludedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_access_included(inputs)
});